export const PERSISTENT_PARAMS = ['type', 'rows'] as const

/**
 * Filters URLSearchParams to only include params that should persist across navigation.
 * Removes transient params like openSettings, openPrint, taskId that are only relevant
 * for specific page states.
 *
 * @param searchParams - The current URLSearchParams to filter
 * @param persistentParams - Optional whitelist of params to persist. Defaults to PERSISTENT_PARAMS.
 * @returns A new URLSearchParams containing only persistent params
 */
export const getPersistedSearchParams = (
  searchParams: URLSearchParams,
  persistentParams: readonly string[] = PERSISTENT_PARAMS
): URLSearchParams => {
  const persistedParams = new URLSearchParams()

  persistentParams.forEach((param) => {
    const value = searchParams.get(param)
    if (value !== null) {
      persistedParams.set(param, value)
    }
  })

  return persistedParams
}
